import Blue from '~/core';

new Blue({
  name: 'Cards',
  selector: '.card--default',
  setup(card) {
    const content = card.querySelector('.card__content');
    let interval;

    const animate = (clear = false) => {
      let start, end;
      start = content.offsetHeight;
      if (!clear) card.classList.add('hover');
      else card.classList.remove('hover');
      end = content.offsetHeight;
      content.animate([{ height: `${start}px` }, { height: `${end}px` }], {
        duration: 250,
        easing: 'ease',
      });
      if (clear) {
        clearInterval(interval);
      }
    };

    const handleHover = () => {
      card.removeEventListener('mouseenter', handleHover);
      animate();
      interval = setInterval(() => {
        if (card.matches(':hover')) return;
        animate(true);
        card.addEventListener('mouseenter', handleHover);
      }, 150);
    };

    card.addEventListener('mouseenter', handleHover);
  },
});
